// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'fast-forward';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M10.854 9.855a1.124 1.124 0 0 0 0-1.715L2.416.825a1.125 1.125 0 0 0-1.853.86V16.31a1.125 1.125 0 0 0 1.853.857z' />
    <path d='M6.75 15.75v.562a1.125 1.125 0 0 0 1.853.857l8.438-7.312a1.125 1.125 0 0 0 0-1.715L8.604.825a1.125 1.125 0 0 0-1.854.86v.565' />
  </g>
);

export const viewBox = '0 0 18 18';
